// Mirrors MerchantScrubberEinCounter on the API: a row counts as an EIN when its
// first column is non-blank, and the header row (if any) is skipped.
// Quote-aware so commas/newlines inside quoted fields don't split rows.
export const countScrubberEins = (text, hasHeaders) => {
  const input = text.replace(/^﻿/, '')
  let count = 0
  let rowIndex = 0
  let firstField = ''
  let fieldIndex = 0
  let inQuotes = false

  const endRow = () => {
    const isDataRow = !(hasHeaders && rowIndex === 0)
    if (isDataRow && firstField.trim() !== '') count += 1
    rowIndex += 1
    firstField = ''
    fieldIndex = 0
  }

  for (let i = 0; i < input.length; i++) {
    const char = input[i]
    if (inQuotes) {
      if (char === '"' && input[i + 1] === '"') {
        if (fieldIndex === 0) firstField += '"'
        i++
      } else if (char === '"') {
        inQuotes = false
      } else if (fieldIndex === 0) {
        firstField += char
      }
    } else if (char === '"') {
      inQuotes = true
    } else if (char === ',') {
      fieldIndex += 1
    } else if (char === '\n' || char === '\r') {
      if (char === '\r' && input[i + 1] === '\n') i++
      endRow()
    } else if (fieldIndex === 0) {
      firstField += char
    }
  }
  if (firstField !== '' || fieldIndex > 0) endRow()

  return count
}
